import { BarChart } from "@mui/icons-material";
import { Box, Card, CardContent, Typography } from "@mui/material";

export const StatCard = ({ stat }) => {
  return (
    <>
      <Card
        sx={{
          height: "100%",
          borderTop: `4px solid ${stat.color}`,
          transition: "transform 0.2s",
          "&:hover": {
            transform: "translateY(-4px)",
          },
        }}
      >
        <CardContent sx={{ p: { xs: 1.5, md: 2 } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 1,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <BarChart
              sx={{
                color: stat.color,
                mr: { xs: 0, md: 1 },
                mb: { xs: 0.5, md: 0 },
                fontSize: { xs: 20, md: 24 },
              }}
            />
            <Typography
              variant="h5"
              fontWeight="bold"
              color={stat.color}
              sx={{
                fontSize: { xs: "1.25rem", md: "2.125rem" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              {stat.value}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: { xs: "0.75rem", md: "0.875rem" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            {stat.title}
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};
